<template>
  <div class="er-wedding-filter">
    <div class="er-wedding-filter--main">
      <div class="er-wedding-filter--filter-container">
        <div
          class="er-wedding-filter--mobile-trigger"
          ref="filterMobileTrigger"
        >
          <button
            class="p-2 hover:bg-gray-100 rounded"
            @click="expandMobileFilter = !expandMobileFilter"
          >
            <svg
              v-if="!expandMobileFilter"
              class="h-5 w-5 fill-beige"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path
                d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
              />
            </svg>
            <svg
              v-else
              class="h-5 w-5 fill-beige"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            >
              <path
                d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"
              />
            </svg>
          </button>
        </div>
        <div
          :class="[expandMobileFilter ? 'block' : 'hidden md:block']"
          class="er-wedding-filter--filters"
          ref="filterGroupContainer"
        >
          <div v-for="group in pageFilters">
            <FilterGroup
              :name="group.name"
              :expanded="group.expanded"
              :items="group.items"
              :selected-items="selectedFilters[group.name.toLocaleLowerCase()]"
              :type="group.type"
              class="mb-4"
              @select="handleSelect"
            />
          </div>
        </div>
      </div>

      <div
        class="er-wedding-filter--product-grid-container"
        ref="productGridContainer"
      >
        <ProductGrid :filters="compiledFilters" :page="pageLabel" />
      </div>
    </div>
  </div>
</template>

<script>
import FilterGroup from "@/components/FilterGroup.vue";
import ProductGrid from "@/components/ProductGrid.vue";
import filters from "@/constants/filters";
import parseFilterString from "@/helpers/parseFilterString";

export default {
  name: "IndexView",
  components: {
    FilterGroup,
    ProductGrid,
  },
  data() {
    return {
      selectedFilters: {},
      filters,
      expandMobileFilter: false,
    };
  },

  provide() {
    return {
      getIsExpandedMobileFilter: () => this.expandMobileFilter,
    };
  },

  methods: {
    handleSelect(itemObj) {
      itemObj.group = itemObj.group.toLowerCase();
      itemObj.item = itemObj.item.toLowerCase();

      const yOffset = -100;
      const productGridContainer = this.$refs.productGridContainer;
      const y =
        productGridContainer.getBoundingClientRect().top +
        window.scrollY +
        yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
      // this.$refs.productGridContainer.scrollIntoView({ behavior: "smooth" });

      const newSelectedFilters = { ...this.selectedFilters };
      if (!newSelectedFilters[itemObj.group]) {
        newSelectedFilters[itemObj.group] = [itemObj.item];
        this.selectedFilters = newSelectedFilters;
        return;
      }

      const itemIndex = newSelectedFilters[itemObj.group].indexOf(itemObj.item);
      if (itemIndex < 0) {
        newSelectedFilters[itemObj.group].push(itemObj.item);
      } else {
        newSelectedFilters[itemObj.group].splice(itemIndex, 1);
      }

      this.selectedFilters = newSelectedFilters;
    },
  },

  computed: {
    compiledFilters() {
      let filters = [];
      for (const key in this.selectedFilters) {
        filters = [...this.selectedFilters[key], ...filters];
      }

      return filters;
    },

    pageFilters() {
      const page = this.filters.pages.find(
        (page) => page.name === this.pageLabel
      );
      return page?.filterGroups || [];
    },

    pageLabel() {
      return this.shopSettings.page;
    },
  },
  watch: {
    selectedFilters: {
      deep: true,
      handler(val) {
        const queryStrings = [];
        for (const key in val) {
          if (!val[key].length) continue;

          let finalQuery = key + "=";
          const queryValues = [];

          for (const value of val[key]) {
            queryValues.push(value);
          }

          const valuesString = queryValues.join(",");
          finalQuery += valuesString;

          queryStrings.push(finalQuery);
        }

        const combinedQueries = queryStrings.join("&");
        this.shopSettings.filters = combinedQueries;
      },
    },
  },

  mounted() {
    const preLoadedFilters = this.shopSettings.filters;
    this.selectedFilters = parseFilterString(preLoadedFilters);
  },
};
</script>

<style lang="scss">
$topOffset: 135;

.er-wedding-filter {
  @apply md:px-5 my-0 mx-auto max-w-screen-lg;

  &--main {
    @apply flex md:grid md:grid-cols-3 gap-3;
  }

  &--filter-container {
    @apply border-r py-2 px-3 md:border-r-0 md:col-span-1;
  }

  &--mobile-trigger {
    @apply text-left top-[135px] md:hidden sticky mb-6 z-10;
  }

  &--filters {
    @apply w-44 md:w-full sticky top-[185px] max-h-[64svh] md:max-h-[75vh] overflow-auto md:top-[135px];
    top: calc($topOffset + 30);
  }

  &--product-grid-container {
    @apply p-4 md:col-span-2 w-full;
  }
}
</style>
